import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { Providers } from './app/providers';
import { initNativeShell } from './lib/native';
import { initTheme } from './lib/theme';
import './index.css';

window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault();
  const key = 'family-pco-chunk-reload';
  const last = Number(sessionStorage.getItem(key) ?? 0);
  if (Date.now() - last < 10_000) return;
  sessionStorage.setItem(key, String(Date.now()));
  void caches
    .keys()
    .then((keys) => Promise.all(keys.map((name) => caches.delete(name))))
    .catch(() => undefined)
    .finally(() => window.location.reload());
});

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

initTheme();
void initNativeShell();

createRoot(root).render(
  <StrictMode>
    <Providers>
      <App />
    </Providers>
  </StrictMode>,
);
